module.exports = __webpack_public_path__ + "img/vertical_4_5_5012.ec059a46.png";